import React from "react";
import { Container, Row } from "react-bootstrap";
import { withTranslation } from 'react-i18next';
import { Empty, Typography } from "antd";
import ProductCard from "../Comman/ProductCard";

const Category = ({ t, ProductData }) => {
 
  if (ProductData?.length === 0) {
    return (
      <div className="grid content-center h-[380px]">
        <Empty description={
          <Typography.Text>
            {t('no_data')}
          </Typography.Text>
        }
        />
      </div>
    );
  }

  return (
    <Container>
      <p className={"section-header"}>{t('cp')}</p>
      <Row>
        {ProductData.map((product, i) => (
          <ProductCard key={i} product={product} />
        ))}
      </Row>
    </Container>
  );
};

export default withTranslation()(Category);
